import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Translation } from 'cng-common/features/translations/components/translation'

import { TRANSLATION_KEYS } from '../../../translations/TRANSLATION_KEYS'

import styles from './Warnings.module.scss'

interface IProps {
  wip: boolean
  showFirstFilterText: boolean
  isFilterWasChanged: boolean
}

export const Warnings = ({ wip, showFirstFilterText, isFilterWasChanged }: IProps) => {
  return (
    <div className={classNames(styles.root, { [styles.hide]: wip })}>
      <RenderWhen condition={showFirstFilterText}>
        <div className={classNames(styles.message, styles.message__initText)}>
          <Translation span text={TRANSLATION_KEYS.initialText} />
        </div>
      </RenderWhen>
      <RenderWhen condition={!showFirstFilterText && isFilterWasChanged}>
        <div className={classNames(styles.message, styles.message__attention)}>
          <Translation text={TRANSLATION_KEYS.filterWasChanged} />
        </div>
      </RenderWhen>
    </div>
  )
}
